import {Component, EventEmitter, Input, Output} from '@angular/core';
import * as EmployeeModels from '@employee-models/index';
import {FilterConfig, RequestReason} from '@employee-pages/badge-request-page/employee-badge-requests';
import {BadgeReasonEnum} from '@employee-models/data.enums';

@Component({
    selector: 'employee-request-details-desktop',
    templateUrl: './employee-request-details-desktop.component.html',
    styleUrls: ['./employee-request-details-desktop.component.less']
})

export class EmployeeRequestDetailsDesktopComponent {
    @Input() requestData: EmployeeModels.DM.IBadgeRequestInfoEmployee;
    @Input() requestReasonPayload: EmployeeModels.CM.IBadgeRequestPayloadModel;
    @Input() tabs: Array<RequestReason>;
    @Input() locationFilterConfig: FilterConfig;

    @Output() onRequestReasonSelect = new EventEmitter<RequestReason>();
    @Output() onLocationSelect = new EventEmitter<number>();
    @Output() onPreferredFullNameSelected = new EventEmitter<boolean>();
    @Output() onBloodGroupSelected = new EventEmitter<string>();

    readonly badgeRequestTypeEnum = EmployeeModels.DE.BadgeRequestTypeEnum;
    readonly badgeChangeReasonsCategories = BadgeReasonEnum;

    get isNoteBlockShown(): boolean {
        return [
            this.badgeChangeReasonsCategories.BadgeLost,
            this.badgeChangeReasonsCategories.BadgeStolen,
            this.badgeChangeReasonsCategories.BadgeDamaged
        ].includes(this.requestReasonPayload.reason);
    }

    get isResubmission(): boolean {
        return this.requestData.badgeRequestType === EmployeeModels.DE.BadgeRequestTypeEnum.Resubmission
            && this.requestData.lastBadgeRequestReason in EmployeeModels.DE.BadgeReasonEnum;
    }

    get isFullNameChecked(): boolean {
        if (this.requestReasonPayload.isNameChanges) {
            return !this.requestReasonPayload.isPreferredFullName;
        }

        return !this.requestData.isPreferredFullName || (this.requestData.isPreferredFullName && !this.isResubmission);
    }

    get selectedBloodType(): string {
        return this.requestData.bloodGroups
        .find(i => i.bloodGroupId === this.requestReasonPayload.bloodGroupId)?.bloodGroupName || '';
    }

    pickRequestReason(tab: RequestReason): void {
        this.onRequestReasonSelect.emit(tab);
    }

    locationChanged(site: EmployeeModels.DM.ISiteDto): void {
        this.onLocationSelect.emit(site.siteId);
    }

    onChangeName(isPreferredFullName: boolean): void {
        this.onPreferredFullNameSelected.emit(isPreferredFullName);
    }

    onBloodGroupChange(bloodGroupName: string): void {
        this.onBloodGroupSelected.emit(bloodGroupName);
    }

}
